/**
 * SponsorshipAdminPage — /admin/sponsorship
 * Platform admin page for managing sponsor seat assignments.
 * Auth-guarded to platform admin only.
 */
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useAdmin } from '@/hooks/useAdmin'
import { SponsorshipAdmin } from '@/components/admin/SponsorshipAdmin'

export default function SponsorshipAdminPage() {
  const { user, isLoading } = useAuth()
  const { isAdmin, loading: adminLoading } = useAdmin()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && !adminLoading && (!user || !isAdmin)) {
      navigate('/learn', { replace: true })
    }
  }, [user, isAdmin, isLoading, adminLoading, navigate])

  if (isLoading || adminLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted">
        <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    )
  }

  if (!isAdmin) return null

  return <SponsorshipAdmin />
}
